import React from 'react';
import { Toast, ToastHeader, ToastBody } from 'reactstrap';
import { formatEuro } from '../../../app/Utils';
import { StarRating } from './StarRating';
import { ProductImage } from './ProductImage';
import ecoSign from "../../images/ecoSign.png";
import newProduct from "../../images/newProduct.png";
import { ReceiptDetailDto } from '../../../../store/models/CustomerInteractionDto';

interface ProductCardProps {
  product: ReceiptDetailDto;
  imageFolder: string;
  isSelected: boolean;
  onClick: () => void;
}

export const ProductCard: React.FC<ProductCardProps> = ({
  product,
  imageFolder,
  isSelected,
  onClick
}) => {
  const { itemInfo, salesPrice } = product;

  return (
    <Toast
      className={isSelected ? "bg-info" : ""}
      style={{
        textAlign: "center",
        cursor: "hand",
      }}
    >
      <ToastHeader>
        {itemInfo.supplierDesc === "New" && (
          <img src={newProduct} alt="Neu" title="Neu" style={{ height: "21px", paddingRight: "10px" }} />
        )}
        {itemInfo.organic && (
          <img src={ecoSign} alt="Bio" title="Bio" style={{ height: "21px", paddingRight: "10px" }} />
        )}
        {itemInfo.supplierItemText}
      </ToastHeader>
      <ToastBody style={{ padding: 0 }}>
        <ProductImage
          imageFolder={imageFolder}
          refNumber={itemInfo.refNumber}
          altText={itemInfo.supplierItemText}
        />
        <StarRating rating={itemInfo.rating} votings={itemInfo.votings} />
        <big style={{ paddingLeft: "128px" }}>
          <b>{formatEuro(salesPrice)}</b>
        </big>
      </ToastBody>
    </Toast>
  );
};